import { defineMessages } from "react-intl";

export default defineMessages({
  creditCard: {
    id: "configureCreditCard.creditCard",
    defaultMessage: "Credit card",
  },
  tryLaterOrAnotherCard: {
    id: "configureCreditCard.tryLaterOrAnotherCard",
    defaultMessage:
      "Something went wrong. Please try later or select another payment method.",
  },
  goBack: {
    id: "configureCreditCard.goBack",
    defaultMessage: "Go back",
  },
  changePaymentMethod: {
    id: "configurePreferredPaymentMethod.changePaymentMethod",
    defaultMessage: "(Change payment method)",
  },
  submit: {
    id: "configurePreferredPaymentMethod.submit",
    defaultMessage: "Submit",
  },
  noPaymentBeforeService: {
    id: "configurePreferredPaymentMethod.noPaymentBeforeService",
    defaultMessage: "No payment before the service.",
  },
  choosePaymentMethodAndPayService: {
    id: "configurePreferredPaymentMethod.choosePaymentMethodAndPayService",
    defaultMessage: "Choose your payment method and pay the service",
  },
});
